import * as Sentry from "@sentry/vue";
import AlertRequestQuery from "~/entities/AlertRequestQuery";
import ValidationModule from "~/entities/ValidationModule";

export default class ValidationQBP extends ValidationModule {
  public QBPTopShopsAlerts = {
    selector: {},
    needle: [""],
  };
  public businessNameInvalid = false;
  public ownerNameInvalid = false;
  public emailInvalid = false;
  public phoneInvalid = false;

  public constructor() {
    super("");
    this.resetValidations();
    this.alertNames = [];
    this.alertTypes = {
      post: this.QBPTopShopsAlerts,
    };
  }

  public async Validate(scope: string = "") {
    this.resetValidations();
    var isValid = true;
    if (
      !this.component.businessName ||
      this.component.businessName.length < 3
    ) {
      this.businessNameInvalid = true;
      isValid = false;
    } else {
      this.businessNameInvalid = false;
    }
    if (!this.component.ownerName || this.component.ownerName.length < 2) {
      this.ownerNameInvalid = true;
      isValid = false;
    } else {
      this.ownerNameInvalid = false;
    }
    if (
      !this.component.email ||
      !this.component.$refs?.qbpEmail?.checkValidity()
    ) {
      this.emailInvalid = true;
      isValid = false;
    } else {
      this.emailInvalid = false;
    }
    if (
      !this.component.phone ||
      !this.validatePhoneNumber(this.component.phone)
    ) {
      this.phoneInvalid = true;
      isValid = false;
    } else {
      this.phoneInvalid = false;
    }
    return isValid;
  }
  public resetValidations() {
    this.validated = false;
    this.validationMade = false;
    this.validationErrors = [];
    this.component?.clearActiveNotices();
  }
  public requestAlert(data: any) {
    this.component?.requestAlert(this.getFilteredAlertKey(data, "asObject"));
  }
  public addNotice(data: any) {
    this.component?.addNotice(this.getFilteredAlertKey(data));
  }
  public removeNotice(data: any) {
    this.component?.removeNotice(this.getFilteredAlertKey(data));
  }
  protected getFilteredAlertKey(
    data: any,
    returnType: string = "asString"
  ): any {
    let keyGetter = new AlertRequestQuery();
    if (data.hasOwnProperty("type")) {
      switch (data.type) {
        default:
          Sentry.addBreadcrumb({
            category: "ValidationQBP.getFilteredAlertKey",
            level: "warning",
            message: "Unknown data type in getFilteredAlertKey",
            data: { dataType: data.type }
          });
      }
    } else {
      //fill
    }
    let filteredData = keyGetter.getKey(
      this.alertNames,
      this.alertTypes[data.type]
    );
    if (returnType == "asString") {
      return filteredData.name;
    } else {
      return filteredData;
    }
  }

  public validatePhoneNumber(phone: string) {
    const phoneRegex =
      /^\+?(\d{1,4})?[-.\s(]*(\d{3})[-.\s)]*(\d{3})[-.\s]*(\d{4})[-.\s]*(?:x(\d+))?$/gm;
    return phoneRegex.test(phone);
  }
  public validateEmail(email: string) {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }
}
